<form [formGroup]="proposedNamesForm" (ngSubmit)="confirm()">
	<div class="subheading">Name Reservation</div>

	<div class="form-group required">
		<label class="control-label">Proposed Names</label>

		<input type="text" class="form-control" formControlName="name_1" placeholder="1st Proposed Name" />
		@if (proposedNamesForm | shouldShowError : 'name_1' : 'reservedWord') {
			<p class="text-danger">Please avoid name extensions such as "PTY" or "CC".</p>
		}
		@if (proposedNamesForm | shouldShowError : 'name_1' : 'invalidCipcNameFormat') {
			<p class="text-danger">Only letters, numbers, and single spaces between words are allowed.</p>
		}

		<input
			type="text"
			class="form-control"
			formControlName="name_2"
			placeholder="2nd Proposed Name (recommended)"
		/>
		@if (proposedNamesForm | shouldShowError : 'name_2' : 'reservedWord') {
			<p class="text-danger">Please avoid name extensions such as "PTY" or "CC".</p>
		}
		@if (proposedNamesForm | shouldShowError : 'name_2' : 'invalidCipcNameFormat') {
			<p class="text-danger">Only letters, numbers, and single spaces between words are allowed.</p>
		}

		<input
			type="text"
			class="form-control"
			formControlName="name_3"
			placeholder="3rd Proposed Name (recommended)"
		/>
		@if (proposedNamesForm | shouldShowError : 'name_3' : 'reservedWord') {
			<p class="text-danger">Please avoid name extensions such as "PTY" or "CC".</p>
		}
		@if (proposedNamesForm | shouldShowError : 'name_3' : 'invalidCipcNameFormat') {
			<p class="text-danger">Only letters, numbers, and single spaces between words are allowed.</p>
		}

		<input
			type="text"
			class="form-control"
			formControlName="name_4"
			placeholder="4th Proposed Name (recommended)"
		/>
		@if (proposedNamesForm | shouldShowError : 'name_4' : 'reservedWord') {
			<p class="text-danger">Please avoid name extensions such as "PTY" or "CC".</p>
		}
		@if (proposedNamesForm | shouldShowError : 'name_4' : 'invalidCipcNameFormat') {
			<p class="text-danger">Only letters, numbers, and single spaces between words are allowed.</p>
		}
	</div>

	<div class="form-group">
		<b>Please note:</b><br />
		Name availability tests are no longer offered by CIPC and we are unable to guarantee a successful name
		reservation. However,
		<a
			href="https://www.brandlaw.co.za/search?utm_source=infodocs&amp;utm_medium=app&amp;utm_campaign=April%2024"
			target="_blank"
			>BrandLaw</a
		>
		offers free trademark searches.
	</div>

	<p class="align-right"><span class="required">*</span> Indicates a required field</p>

	<div class="modal-footer">
		<a class="btn-nav btn-prev" (click)="close()">Back</a>
		<app-submit-button
			[isDisabled]="!proposedNamesForm.valid"
			submitLabel="Next"
			(clicked)="confirm()"
		/>
	</div>
</form>
